import { render, staticRenderFns } from "./Start.vue?vue&type=template&id=7c30d02a&scoped=true&"
import script from "./Start.vue?vue&type=script&lang=ts&"
export * from "./Start.vue?vue&type=script&lang=ts&"
import style0 from "./Start.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Start.vue?vue&type=style&index=1&id=7c30d02a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c30d02a",
  null
  
)

export default component.exports